<script>
	import { Col, Row, Container } from 'sveltestrap';
</script>

<section class="section-sm bg-light">
	<Container>
		<Row>
			<Col md={3}>
				<div class="client-images my-3 my-md-0">
					<img src="images/clients/1.png" alt="logo-img" class="mx-auto img-fluid d-block" />
				</div>
			</Col>

			<Col md={3}>
				<div class="client-images my-3 my-md-0">
					<img src="images/clients/2.png" alt="logo-img" class="mx-auto img-fluid d-block" />
				</div>
			</Col>

			<Col md={3}>
				<div class="client-images my-3 my-md-0">
					<img src="images/clients/3.png" alt="logo-img" class="mx-auto img-fluid d-block" />
				</div>
			</Col>

			<Col md={3}>
				<div class="client-images my-3 my-md-0">
					<img src="images/clients/4.png" alt="logo-img" class="mx-auto img-fluid d-block" />
				</div>
			</Col>
		</Row>
	</Container>
</section>